'use client'

import React, { forwardRef } from 'react'
// Learn more at https://www.radix-ui.com/docs/primitives/components/popover
import { Root, Trigger, Content, Arrow, Portal } from '@radix-ui/react-popover'

import { arrowStyles, tipStyles } from '../Tooltip/styles'
import { ToggletipProps } from './Toggletip.types'

export const Toggletip = forwardRef<HTMLButtonElement, ToggletipProps>(
  (
    {
      className = '',
      children,
      content,
      testId = '',
      onOpenChange,
      addButtonWrapper = true,
      triggerClassName = '',
      open,
    },
    ref,
  ) => {
    return (
      <Root open={open} onOpenChange={onOpenChange}>
        {/* When asChild is true, Radix moves the props and behavior into the children itself
          This is so a toggletip-wrapped button doesn't become a button in a button */}
        <Trigger
          asChild={!addButtonWrapper}
          className={triggerClassName}
          data-testid={testId}
          ref={ref}
        >
          {children}
        </Trigger>
        <Portal>
          <Content
            className={`${className} ${tipStyles({
              component: 'toggletip',
            })} pointer-events-auto`}
            //The distance in pixels from the boundary edges where collision detection should occur.
            collisionPadding={16}
            sideOffset={4}
            // 8px padding goes on the right and left of the arrow.
            // It makes it so the arrow is not touching the tip's border radius
            arrowPadding={8}
          >
            {/* The extra div insures the last child of the content is treated as the
            last child (ex: p:last:mb-0). Without it, the toggletip's arrow is the last
            child */}
            <div>{content}</div>
            <Arrow className={arrowStyles} width={8} height={4} />
          </Content>
        </Portal>
      </Root>
    )
  },
)

Toggletip.displayName = 'Toggletip'
